import { put, takeLatest } from 'redux-saga/effects';
import { UserAPI, UserProfileInfo } from 'api/user';
import { StoreActionProps } from 'data/core';
import { success } from 'data/current-user-profile';
import { logger } from 'services';
import {
  saveCurrentUserProfileSagaAction,
  SaveCurrentUserPayload,
} from '../actions';

function* saveCurrentUserProfileSaga(
  action: StoreActionProps<SaveCurrentUserPayload>,
) {
  const {
    payload: { user, handleError, handleSuccess, handleAlways },
  } = action;

  try {
    const profile = yield UserAPI.save(user);

    yield put(success({ user: profile } as unknown as UserProfileInfo));

    if (handleSuccess) {
      handleSuccess();
    }
  } catch (error) {
    logger.error('User save failed', { error });

    if (handleError) {
      handleError();
    }
  }

  if (handleAlways) {
    handleAlways();
  }
}

export const watchSaveCurrentUserProfileSaga = function* (): Generator {
  yield takeLatest(
    saveCurrentUserProfileSagaAction.type,
    saveCurrentUserProfileSaga,
  );
};
